import {
    server
} from "@/api";

const prefix = 'api/services'
const adminPrefix = 'api/admin/services'

export const admin = {
    create: async (service) => {
        return await server().post(adminPrefix, service, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
    },
    all: async (params) => {
        return await server().get(`${adminPrefix}/all`, { params });
    },
    get: async (id, params = {}) => {
        return await server().get(`${adminPrefix}/${id}`, { params });
    },
    paginate: async (params) => {
        return await server().get(adminPrefix, { params });
    },
    update: async (id, service) => {
        return await server().post(`${adminPrefix}/${id}`, service, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    },
    destroy: async (id) => {
        return await server().delete(`${adminPrefix}/${id}`);
    },
    edit: async (id) => {
        return await server().get(`${adminPrefix}/${id}/edit`);
    }
}

export const create = async (service) => {
    return await server().post(prefix, service, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
}

export const get = async (id) => {
    return await server().get(`${prefix}/${id}`)
}

export const update = async (id, service) => {
    return await server().post(`${prefix}/${id}`, service, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
}

export const destroy = async (id) => {
    return await server().delete(`${prefix}/${id}`)
}

export const paginate = async (params) => {
    return await server().get(`${prefix}`, { params })
}

export const all = async () => {
    return await server().get(`${prefix}/all`)
}